import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FileQuestion, ArrowLeft, Home } from 'lucide-react';
import { Button } from '../Components/ui/button';

export default function NotFound() {
    return (
        <div className="min-h-[80vh] flex flex-col items-center justify-center px-4 sm:px-6 lg:px-8 text-center bg-background">
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="relative mb-8"
            >
                <div className="absolute inset-0 blur-3xl opacity-20 bg-primary/30 rounded-full animate-pulse"></div>
                <FileQuestion size={120} className="text-primary relative z-10" />
            </motion.div>

            <motion.h1
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                className="text-6xl md:text-8xl font-black text-foreground mb-4 tracking-tighter"
            >
                404
            </motion.h1>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3, duration: 0.5 }}
            >
                <h2 className="text-2xl md:text-3xl font-bold text-foreground/80 mb-6">
                    Pagina non trovata
                </h2>
                <p className="max-w-md mx-auto text-muted-foreground mb-10 text-lg leading-relaxed">
                    Spiacenti, la pagina che stai cercando non esiste o è stata spostata.
                    Niente paura, possiamo aiutarti a tornare in carreggiata.
                </p>
            </motion.div>

            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4, duration: 0.5 }}
                className="flex flex-col sm:flex-row gap-4"
            >
                <Button asChild size="lg" className="rounded-full px-8 shadow-lg shadow-primary/20 transition-all hover:scale-105 active:scale-95">
                    <Link to="/" className="flex items-center gap-2">
                        <Home size={18} />
                        Torna alla Home
                    </Link>
                </Button>
                <Button asChild variant="outline" size="lg" className="rounded-full px-8 transition-all hover:bg-muted active:scale-95">
                    <button onClick={() => window.history.back()} className="flex items-center gap-2">
                        <ArrowLeft size={18} />
                        Pagina precedente
                    </button>
                </Button>
            </motion.div>

            {/* Modern mesh background pattern */}
            <div className="fixed inset-0 -z-10 h-full w-full bg-background bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px] [mask-image:radial-gradient(ellipse_50%_50%_at_50%_50%,#000_70%,transparent_100%)] opacity-20"></div>
        </div>
    );
}
